<div class="modal-backdrop" (click)="onClose()"></div>

<div class="modal">
  <div class="modal-header">
    <div>
      <h2>Assign Distributors</h2>
      <p class="modal-subtitle">Select distributors and provide retailer codes for <strong>{{retailerName}}</strong></p>
    </div>
    <span class="icon-btn" (click)="onClose()">
      <i class="fas fa-times"></i>
    </span>
  </div>

  <div class="modal-body">
    <!-- Search Box -->
    <div class="search-wrapper">
      <i class="fas fa-search search-icon"></i>
      <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search distributors by name or email..." class="search-input" />
      <span *ngIf="searchTerm" class="clear-search" (click)="clearSearch()">
        <i class="fas fa-times"></i>
      </span>
    </div>

    <!-- Selected Count -->
    <div class="selection-info" *ngIf="getSelectedCount() > 0">
      <span class="selection-badge">{{getSelectedCount()}}</span> distributor{{getSelectedCount() > 1 ? 's' : ''}} selected
    </div>

    <!-- Distributor List -->
    <div class="distributor-list">
      <div *ngIf="loading || loadingExisting" class="empty-state">
        <i class="fas fa-spinner fa-spin"></i>
        <p>{{ loadingExisting ? 'Loading existing assignments...' : 'Loading distributors...' }}</p>
      </div>

      <div *ngIf="!loading && !loadingExisting && displayedDistributors.length === 0 && searchTerm" class="empty-state">
        <i class="fas fa-search"></i>
        <p>No distributors found matching "{{searchTerm}}"</p>
      </div>

      <div *ngIf="!loading && !loadingExisting && displayedDistributors.length === 0 && !searchTerm" class="empty-state">
        <i class="fas fa-users"></i>
        <p>No distributors available</p>
      </div>

      <div *ngFor="let dist of displayedDistributors; trackBy: trackByDistId"
        class="distributor-item" [class.selected]="dist.isSelected">

        <div class="distributor-row">
          <label class="checkbox-wrapper">
            <input type="checkbox" [(ngModel)]="dist.isSelected" (change)="onSelectionChange(dist)" />
            <span class="checkmark"></span>
          </label>

          <div class="distributor-info">
            <div class="distributor-name">{{dist.distributor_name}}</div>
            <div class="distributor-email">{{dist.email}}</div>
          </div>
        </div>

        <!-- Retailer Code Input (shown when selected) -->
        <div class="retailer-code-row" *ngIf="dist.isSelected">
          <div class="retailer-code-field">
            <input type="text" [(ngModel)]="dist.retailerCode" (input)="onRetailerCodeChange(dist)" placeholder=" " [attr.name]="'retailer_code_' + dist.id" />
            <label>Retailer Code <span style="color: #dc2626;">*</span></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="errorMsg" style="padding: 0 24px 12px; color: #dc2626; font-size: 13px; text-align: center;">
    <i class="fas fa-exclamation-circle"></i> {{errorMsg}}
  </div>

  <div class="modal-footer">
    <button class="btn secondary" type="button" (click)="onClose()">Cancel</button>
    <button class="btn primary" type="button" (click)="onSubmit()" [disabled]="submitting">
      {{ submitting ? 'Assigning...' : 'Assign Distributors' }}
    </button>
  </div>
</div>
